module.exports = __webpack_public_path__ + "img/choose-box-hen.05d93777.png";